import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  title?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorMessage?: string;
}

export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return {
      hasError: true,
      errorMessage: error instanceof Error ? error.message : 'Unknown error'
    };
  }

  componentDidCatch(error: unknown) {
    // Keep this visible in production debugging if needed
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Caught error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container" style={{ padding: '2rem 1rem' }}>
          <h2>{this.props.title || 'Something went wrong'}</h2>
          <p style={{ opacity: 0.9 }}>
            The page failed to render. Please refresh and try again.
          </p>
          {this.state.errorMessage && (
            <pre
              style={{
                whiteSpace: 'pre-wrap',
                opacity: 0.8,
                fontSize: '0.9rem'
              }}
            >
              {this.state.errorMessage}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
































